import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useContent } from "../hooks/useContent";
import { useSeo } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Section } from "../components/Primitives";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  const { t, pick } = useI18n();
  useSeo(t("nav.faq"), "Questions fréquentes sur la Résidence Doux Instants à Laval : catégorie, soins, repas, visites et tarifs.");
  const { data: faq = [] } = useContent("faq");

  return (
    <>
      <PageHero eyebrow={t("nav.faq")} title={t("home.faqTitle")} />
      <Section tone="surface">
        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {faq.map((f) => (
              <AccordionItem key={f.id} value={f.id}>
                <AccordionTrigger className="text-left text-lg">{pick(f.q)}</AccordionTrigger>
                <AccordionContent className="text-[15px] text-[#5C6370]">{pick(f.a)}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </Section>
    </>
  );
}
